import Index from "../../../Index";
import React, { useState } from "react";
import PagesIndex from "../../../PagesIndex";
import { useEffect } from "react";
import {
  getSubSahaylist,
  multipleDeleteSubSahay,
  subSahaylistDelete,
} from "../../../../redux/features/AddService";
import { STATUSES } from "../../../../redux/features/adminslice/AdminSlice";
import moment from "moment";
import { useSelector } from "react-redux";
import PageLoading from "../../../../components/common/pageLoading/PageLoading";
import RowPerPageDropdown from "../../../../components/common/paginationRowPerpage/RowPerPageDropdown";
import { useLocation } from "react-router-dom";
import { Autocomplete } from "@mui/material";

const ProgramReportMemberView = () => {
  //useselector

  //navigate and dispatch
  const navigate = PagesIndex.useNavigate();
  const location = useLocation();
  const [filterReportData, setFilterReportData] = useState([]);
  const pageData = location.state;
  const [filter, setFilter] = useState("");
  useEffect(() => {
    const filters = {
      familyId: filter
    };
    const filterData = pageData?.filter((ele) => {
      if (Object.values(filters).some(Boolean)) {
        return Object.entries(filters).every(([key, value]) => {
          if (!value) return true;
          return ele[key] == value;
        });
      } else {
        return true;
      }
    });
    setFilterReportData(filterData);
  }, [
    filter
  ]);
  return (
    <>
      <Index.Box className="page-content-box">
        <Index.Box className="barge-common-box">
          <Index.Box className="title-header">
            <Index.Box className="title-header-flex res-title-header-flex">
              <Index.Box>
                <Index.Box className="plus-hidden-show-mobile">
                  <Index.Box className="title-main">
                    <Index.Typography
                      variant="p"
                      component="p"
                      className="page-title"
                    >
                      Program Report Members
                    </Index.Typography>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
              <Index.Box className="FID-back">
                <Index.Box
                  gridColumn={{
                    xs: "span 12",
                    sm: "span 6",
                    md: "span 3",
                    lg: "span 3",
                  }}
                  className="grid-column"
                >
                  <Index.Box className="sahay-multiple-input-main">
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      className="multiple-autocomplet-control fix"
                      options={filterReportData || []}
                      getOptionLabel={(option) => option?.familyId}
                      onChange={(value, newvalue) => {
                        setFilter(newvalue?.familyId);
                      }}
                      filterOptions={(options, { inputValue }) => {
                        const inputLowerCase = inputValue?.toLowerCase();
                        const uniqueFamilyId = new Set();
                        return options?.filter((option) => {
                          const familyId =
                            option?.familyId?.toString()?.toLowerCase();
                          // Check unique
                          if (uniqueFamilyId?.has(familyId)) {
                            return false;
                          }
                          // Check search
                          if (familyId?.includes(inputLowerCase)) {
                            uniqueFamilyId?.add(familyId);
                            return true;
                          }
                          return false;
                        });
                      }}
                      renderInput={(params) => (
                        <Index.TextField {...params} label="FID"/>
                      )}
                    />
                  </Index.Box>
                </Index.Box>
                <Index.Box className="d-flex align-items-center res-set-search">
                  {/* <PagesIndex.Search
                      className="search"
                    //   onChange={(e) => requestSearch(e.target.value)}
                    >
                      <PagesIndex.StyledInputBase
                        placeholder="Search"
                        inputProps={{ "aria-label": "search" }}
                      />
                    </PagesIndex.Search> */}
                  <>

                    <Index.Box className="common-button blue-button res-blue-button desk-hidden-show">
                      <Index.Link
                        to={`/admin/program-report`}
                        className="no-text-decoration"
                      >
                        {" "}
                        <Index.Button variant="contained" disableRipple>
                          Back
                        </Index.Button>
                      </Index.Link>
                    </Index.Box>
                  </>
                </Index.Box>
              </Index.Box>
            </Index.Box>
          </Index.Box>

          <Index.Box className="sahay-table">
            <Index.TableContainer
              sx={{ maxHeight: 450 }}
              // component={Index.Paper}
              className="table-container  sub-type-list-container scroll-table common-table-container-custom"
            >
              <Index.Table
                stickyHeader
                aria-label="sticky table"
                className="table-design-main barge-table sub-type-list-table adjust-list-table"
              >
                <Index.TableHead className="sub-type-list-head">
                  <Index.TableRow className="sub-type-list-tr">
                    <Index.TableCell className="sub-type-list-th">
                      S.No.
                    </Index.TableCell>
                    <Index.TableCell className="sub-type-list-th">
                      Family Id
                    </Index.TableCell>
                    <Index.TableCell className="sub-type-list-th">
                      Member Id
                    </Index.TableCell>
                    <Index.TableCell className="sub-type-list-th">
                      Member Name
                    </Index.TableCell>
                    <Index.TableCell className="sub-type-list-th" align="left">
                      Amount
                    </Index.TableCell>
                  </Index.TableRow>
                </Index.TableHead>
                <Index.TableBody>
                  {filterReportData?.length ? (
                    filterReportData?.map((data, index) => (
                      <Index.TableRow key={index} className="sub-type-list-tr">
                        <Index.TableCell
                          className="sub-type-list-td"
                          key={index}
                        >
                          {index + 1}
                        </Index.TableCell>
                        <Index.TableCell
                          className="sub-type-list-td"
                          key={data.Id}
                        >
                          {data?.familyId}
                        </Index.TableCell>
                        <Index.TableCell
                          className="sub-type-list-td"
                          key={index}
                        >
                          {data?.memberId}
                        </Index.TableCell>
                        <Index.TableCell
                          className="sub-type-list-td"
                          align="left"
                        >
                          {" "}
                          {data?.memberName}
                        </Index.TableCell>
                        <Index.TableCell
                          className="sub-type-list-td"
                          key={data.Id}
                        >
                          {data?.amount}
                        </Index.TableCell>
                      </Index.TableRow>
                    ))
                  ) : (
                    <PagesIndex.NoRecordFound colSpan={12} />
                  )}

                  {pageData?.length && (
                    <Index.TableRow className="sub-type-list-tr">
                      <Index.TableCell
                        className="sub-type-list-td"
                        align="left"
                      >
                        <Index.Typography component="strong">
                          Total Amount
                        </Index.Typography>
                      </Index.TableCell>
                      <Index.TableCell
                        className="sub-type-list-td"
                        align="left"
                      ></Index.TableCell>
                      <Index.TableCell
                        className="sub-type-list-td"
                        align="left"
                      ></Index.TableCell>
                      <Index.TableCell
                        className="sub-type-list-td"
                        align="left"
                      ></Index.TableCell>
                      <Index.TableCell
                        className="sub-type-list-td"
                        align="left"
                      >
                        {pageData?.length > 0 &&
                          pageData?.reduce((acc, curr) => {
                            let total;
                            total = acc + curr?.amount;
                            return total;
                          }, 0)}
                      </Index.TableCell>
                    </Index.TableRow>
                  )}
                </Index.TableBody>
              </Index.Table>
            </Index.TableContainer>
          </Index.Box>
          {/* <Index.Box className="pagination-design flex-end">
                <RowPerPageDropdown
                  rowPerPage={rowPerPage}
                  setRowPerPage={setRowPerPage}
                />
                <Index.Stack spacing={2}>
                  <PagesIndex.Pagination
                    fetchData={searchedData}
                    setPageData={setPageData}
                    pageData={pageData}
                    rowPerPage={rowPerPage}
                  />
                </Index.Stack>
              </Index.Box> */}
        </Index.Box>
      </Index.Box>
      {/* <PagesIndex.DeleteModal
            deleteText={deleteText}
            deleteOpen={deleteOpen}
            handleDeleteRecord={handleDeleteRecord}
            handleDeleteClose={handleDeleteClose}
          /> */}
    </>
  );
};

export default ProgramReportMemberView;
